import * as types from './types';

export const selectGroup = group => dispatch => {
  dispatch({
    type: types.SELECT_GROUP,
    payload: group,
  });
};

export const showLoading = showLoading => ({
  type: types.SHOW_LOADING_GROUP,
  payload: showLoading,
});

export const fetchProfiles = Id => dispatch => {};

export const toggleProfileSelect = Id => ({
  type: types.TOGGLE_GROUP_PROFILE_SELECT,
  payload: Id,
});

export const toggleCheckoutSelect = isSelectedForCheckout => ({
  type: types.TOGGLE_GROUP_CHECKOUT_SELECT,
  payload: isSelectedForCheckout,
});

export const account = () => (dispatch, getState) => {};

export const checkout = () => ({
  type: types.CHECKOUT_GROUP,
});



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/group/state/actions.js